var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokensIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7666 11.2858C23.644 13.156 18.8053 14.574 13.0182 14.574C7.42466 14.574 2.72143 13.2587 1.4053 11.4913M24.7666 16.4286C23.644 18.2987 18.8053 19.7167 13.0182 19.7167C7.42466 19.7167 2.72143 18.4015 1.4053 16.6341M25 5.11018C25 7.38016 19.6274 9.22035 13 9.22035C6.37258 9.22035 1 7.38016 1 5.11018C1 2.84019 6.37258 1 13 1C19.6274 1 25 2.84019 25 5.11018Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokensIcon);
export default __webpack_public_path__ + "static/media/tokens-icon.f949cc99.svg";
export { ForwardRef as ReactComponent };